import { Grid, Typography } from "@mui/material";
import PerformanceDashboardBottomRatedPages from "./PerformanceDashboardBottomRatedPages";
import PerformanceDashboardTopRatedPages from "./PerformanceDashboardTopRatedPages";
import "../PerformanceDashboard.css";
import { useSelector } from "react-redux";

const PerformanceDashboardRatedTable = () => {
  const { exequteQueryContentQuery2, pageScanData } = useSelector(
    (state: any) => state.pageSpeedPerformance
  );

  const activePageNames = new Set(
    (pageScanData ?? [])
      .filter((p: any) => p.active === 1)
      .map((p: any) => p.page_name)
  );

  const filteredRows = activePageNames.size > 0
    ? (exequteQueryContentQuery2?.payload ?? []).filter((row: any) =>
        activePageNames.has(row.page_name)
      )
    : exequteQueryContentQuery2?.payload;

  return (
    <>
      <Grid container spacing={3} mb={2} className="ratedTableWrap">
        <Grid item xs={6}>
          <Typography sx={{ fontSize: "18px", color: "#000000" }}>
            Top Rated Pages
          </Typography>
          <PerformanceDashboardTopRatedPages rows={filteredRows} />
        </Grid>
        <Grid item xs={6}>
          <Typography sx={{ fontSize: "18px", color: "#000000" }}>
            Bottom Rated Pages
          </Typography>
          <PerformanceDashboardBottomRatedPages rows={filteredRows} />
        </Grid>
      </Grid>
    </>
  );
};

export default PerformanceDashboardRatedTable;
